import { FC, Fragment } from "react";
import SRC from "./WeAreGettingMarried.jpg";

export const WeAreGettingMarried: FC = () => {
  return (
    <Fragment>
      <div
        className="about-us-desc col-lg-8 offset-lg-2"
        data-animation-direction="from-bottom"
        data-animation-delay="300"
      >
        <h3>
          <small>We are</small>Getting Married
        </h3>
        <p>
          Dear friends and loved ones, we are filled with excitement and joy as
          we invite you to the most important day of our lives — our wedding
          celebration! This moment has become possible thanks to the love that
          has grown and strengthened with each passing day, and now we are ready
          to share it with you, our dearest and closest people.
        </p>
        <p>
          Our day is not just a moment for the two of us, but also an
          opportunity to gather together and celebrate the love that unites us
          all. We will be overjoyed to have you with us on this special occasion
          and to create unforgettable memories filled with warmth, happiness,
          and celebration!
        </p>
        <img src={SRC} alt="Signature" height={80} />
      </div>
    </Fragment>
  );
};
